export const getOrphans = (relations) => Object.values(relations).reduce((orphans, node) => {
    const { parentId, nodeType } = node;
    if (parentId || nodeType === 'init') {
        return orphans;
    }
    orphans.push(node);
    return orphans;
}, []);
